module.exports = __webpack_public_path__ + "static/media/visionforhumanity.66189352.jpg";